module.exports = __webpack_public_path__ + "static/media/microsoft365.81dd5103.svg";